/**
 * useToast — Sonner wrapper hook (shadcn/ui toast API kompatibilis)
 *
 * A RentalWizardPage és más oldalak shadcn/ui-style useToast()-ot várnak.
 * A projekt Sonner-t használ, ez a shim biztosítja a kompatibilitást.
 */
import { toast as sonnerToast } from '@kgc/ui';

interface ToastOptions {
  title: string;
  description?: string;
  /** `warning` = sárga (a `<Toaster richColors>` alatt): siker, de a felhasználónak tudnia kell valamiről. */
  variant?: 'default' | 'destructive' | 'warning';
}

function toast(options: ToastOptions) {
  const { title, description, variant } = options;
  if (variant === 'destructive') {
    sonnerToast.error(title, { description });
  } else if (variant === 'warning') {
    sonnerToast.warning(title, { description });
  } else {
    sonnerToast.success(title, { description });
  }
}

export function useToast() {
  return { toast };
}
